import { Tabs, Button } from 'antd';
import { isEmpty } from 'lodash/fp';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type ModuleListDataFragment } from '../../../api/fragments';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import CtsManagement from './CtsManagement';

type CtsDetailsInnerPageProps = {
    modules: ModuleListDataFragment[];
};

const CtsDetailsInnerPage = ({ modules }: CtsDetailsInnerPageProps) => {
    const { t } = useTranslation(['ctsDetails']);
    const tabs = useMemo(() => modules.map(module => ({ key: module.id, tab: module.displayName })), [modules]);
    const [activeTab, setActiveTab] = useState(tabs?.[0]?.key);
    const module = useMemo(() => (activeTab ? modules.find(({ id }) => id === activeTab) : null), [activeTab, modules]);

    const render = () => {
        if (isEmpty(module)) {
            return null;
        }

        return <CtsManagement key={activeTab} module={module} />;
    };

    return (
        <ConsolePageWithHeader
            footer={[
                <Button key="submit" form={`ctsDetails-${activeTab}`} htmlType="submit" type="primary">
                    {t('ctsDetails:actions.update')}
                </Button>,
            ]}
            header={{
                footer:
                    tabs.length > 1 ? (
                        <Tabs onChange={activeKey => setActiveTab(activeKey)}>
                            {tabs.map(tab => (
                                <Tabs.TabPane key={tab.key} tab={tab.tab} />
                            ))}
                        </Tabs>
                    ) : null,
            }}
            title={t('ctsDetails:title')}
        >
            {render()}
        </ConsolePageWithHeader>
    );
};

export default CtsDetailsInnerPage;
